import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { EnvelopeSimple, Phone, InstagramLogo, LinkedinLogo, YoutubeLogo, FacebookLogo, XLogo, WhatsappLogo } from "@phosphor-icons/react";
import { useConsultModal } from "../ConsultModal";
import { useProSignup } from "../ProfessionalSignupModal";
import { api } from "../../lib/api";

const socialIconMap = {
  instagram: InstagramLogo,
  linkedin: LinkedinLogo,
  x: XLogo,
  youtube: YoutubeLogo,
  facebook: FacebookLogo,
  whatsapp: WhatsappLogo,
};
const socialOrder = [
  { key: "instagram", label: "Instagram", testid: "social-instagram" },
  { key: "linkedin", label: "LinkedIn", testid: "social-linkedin" },
  { key: "x", label: "X / Twitter", testid: "social-x" },
  { key: "youtube", label: "YouTube", testid: "social-youtube" },
  { key: "facebook", label: "Facebook", testid: "social-facebook" },
  { key: "whatsapp", label: "WhatsApp", testid: "social-whatsapp" },
];

export default function Footer() {
  const [settings, setSettings] = useState(null);
  const { open: openConsult } = useConsultModal();
  const { open: openProSignup } = useProSignup();

  useEffect(() => { api.get("/settings/public").then((r) => setSettings(r.data)).catch(() => {}); }, []);

  return (
    <footer className="md-footer-wrap" data-testid="site-footer">
      <div className="md-container">
        <div className="md-footer-grid">
          <div>
            <div className="md-label-eyebrow mb-4">Quick Links</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/therapists">Find a Therapist</Link></li>
              <li><Link to="/events">Events</Link></li>
              <li><Link to="/shop">Shop</Link></li>
              <li><Link to="/articles">Articles</Link></li>
              <li><Link to="/contact?source=footer" data-testid="footer-contact-us">Contact Us</Link></li>
            </ul>
          </div>
          <div>
            <div className="md-label-eyebrow mb-4">Information</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions">Terms and Conditions</Link></li>
              <li><Link to="/refund-cancellation-policy" data-testid="footer-refund-policy">Refund and Cancellation Policy</Link></li>
              <li><Link to="/refer">Refer to Us</Link></li>
              <li><Link to="/faqs" data-testid="footer-faqs">FAQ</Link></li>
              <li><button onClick={openProSignup} className="text-left hover:underline" data-testid="footer-pro-signup">For Professionals</button></li>
            </ul>
          </div>
          <div>
            <div className="md-label-eyebrow mb-4">Couch</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/couch/mental-wellbeing">Mental Wellbeing</Link></li>
              <li><Link to="/couch/cognitive-support">Cognitive Support</Link></li>
              <li><Link to="/couch/pricing">Sessions &amp; Pricing</Link></li>
              <li><Link to="/couch/how-it-works">How It Works</Link></li>
              <li><button onClick={openConsult} className="text-left hover:underline">Free Consultation</button></li>
            </ul>
          </div>
          <div>
            <div className="md-label-eyebrow mb-4">Forward</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/find-a-mentor">Find a Mentor</Link></li>
              <li><Link to="/forward/packages">Packages</Link></li>
              <li><Link to="/forward/how-it-works">How It Works</Link></li>
              <li><Link to="/articles">Articles</Link></li>
            </ul>
          </div>
          <div>
            <div className="md-label-eyebrow mb-4">For Organisations</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/organisations/corporate">Corporate Wellness</Link></li>
              <li><Link to="/organisations/schools">School Workshops</Link></li>
              <li><Link to="/organisations/career-workshops">Psychology Career Workshops</Link></li>
              <li><button onClick={openConsult} className="text-left hover:underline">Talk to Us</button></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="md-footer-entity-band" data-testid="footer-entity-band">
        <div className="md-container md-footer-entity-row">
          <div className="md-footer-info-half">
            <div className="md-footer-legal text-xs" data-testid="footer-legal">
              <div className="md-footer-legal-row">
                <span className="md-footer-legal-label">Registered Entity</span>
                <span>MindDhara Private Limited</span>
              </div>
              <div className="md-footer-legal-row">
                <span className="md-footer-legal-label">CIN</span>
                <span>U86909HR2025PTC136572</span>
              </div>
              <div className="md-footer-legal-row">
                <span className="md-footer-legal-label">Registered Address</span>
                <span>Sector-77, Narsinghpur, Gurgaon, Haryana-122004</span>
              </div>
              <div className="md-footer-legal-row">
                <span className="md-footer-legal-label">Contact</span>
                <span className="md-footer-contact">
                  <a href={`mailto:${settings?.contact_email || "hello@minddhara.com"}`} className="md-contact-chip"><EnvelopeSimple size={13} weight="duotone" /> {settings?.contact_email || "hello@minddhara.com"}</a>
                  {settings?.contact_phone && (
                    <>
                      <a href={`tel:${String(settings.contact_phone).replace(/\s+/g, "")}`} className="md-contact-chip"><Phone size={13} weight="duotone" /> {settings.contact_phone}</a>
                      <a href={`https://wa.me/${String(settings.contact_phone).replace(/[^0-9]/g, "")}`} target="_blank" rel="noreferrer" className="md-contact-chip md-contact-chip-wa"><WhatsappLogo size={13} weight="duotone" /> WhatsApp</a>
                    </>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="md-footer-social-half">
            <div className="md-footer-follow" data-testid="footer-follow">
              <div className="md-label-eyebrow md-footer-follow-heading">Follow Us</div>
              <div className="md-footer-follow-icons" data-testid="footer-socials">
                {socialOrder.map((s) => {
                  const Icon = socialIconMap[s.key];
                  const href = settings?.[`social_${s.key}`];
                  if (!href) return null;
                  return (
                    <a key={s.label} href={href} target="_blank" rel="noreferrer" aria-label={s.label} data-testid={s.testid} className="md-footer-social-btn">
                      <Icon size={16} weight="regular" />
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="md-footer-copy" data-testid="footer-copy">
        <div className="md-container md-footer-copy-row">
          <div className="md-footer-copy-text">
            © {new Date().getFullYear()} MindDhara Private Limited. All rights reserved.
            <span className="md-footer-legal-links">
              <Link to="/privacy-policy" data-testid="footer-privacy">Privacy</Link>
              <span aria-hidden>·</span>
              <Link to="/cookie-policy" data-testid="footer-cookie">Cookies</Link>
              <span aria-hidden>·</span>
              <button onClick={() => window.dispatchEvent(new Event("md:open-cookie-settings"))} className="md-footer-link-btn" data-testid="footer-cookie-settings">Cookie Settings</button>
            </span>
          </div>
          <div className="md-footer-pay" data-testid="footer-payment-icons">
            <span className="md-footer-pay-label">We accept</span>
            <span className="md-footer-pay-badge md-pay-razorpay">Razorpay</span>
            <span className="md-footer-pay-badge md-pay-upi">UPI</span>
            <span className="md-footer-pay-badge md-pay-visa">VISA</span>
            <span className="md-footer-pay-badge md-pay-mastercard">Mastercard</span>
            <span className="md-footer-pay-badge md-pay-rupay">RuPay</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
